<template>
  <f7-popup id="popup-payment-history" class="popup-payment-history">
    <f7-view>
      <f7-page>
        <f7-block v-if="loading" class="loading-data">
          <f7-preloader></f7-preloader>
        </f7-block>

        <div v-if="!loading">
          <f7-block-title>
            Payment History
          </f7-block-title>

          <f7-list>
            <f7-list-item
              v-for="item in history"
              :key="item.id"
              :title="format(new Date(item.created_at), 'dd.MM.yyyy')"
              :after="`${item.amount}$`"
            ></f7-list-item>
          </f7-list>
        </div>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { format } from 'date-fns';
import apiRequest from '@/js/helpers/apiRequest.js';

export default {
  name: 'PopupPaymentHistory',

  data() {
    return {
      loading: true,
      history: []
    };
  },

  computed: {
    format: () => format
  },

  async created() {
    try {
      const res = await apiRequest('team/payments/history', 'GET', null, true);

      this.loading = false;

      if (res.success) {
        this.history = res.success;
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }
};
</script>

<style lang="less">
.popup-payment-history:not(.popup-tablet-fullscreen) {
  --f7-popup-box-shadow: 0px 20px 44px rgba(0, 0, 0, 0.5);

  @media (min-height: 630px) and (min-width: 630px) {
    --f7-popup-tablet-width: 310px;
    --f7-popup-tablet-height: 400px;
  }
}
</style>
